<div class="container-fluid">
  <div class="row" style="margin:0px;padding:0px;">
    <div class="col-12" style="margin:0px;padding:0px;" *ngIf="!ctrlData.isApproval">
       <div class="prx-nav" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
        <ul class="nav-fill" role="tablist" style="margin:0px;padding:0px;">
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-info" (click)="onActive()" [ngClass]="{ 'active':utility.activeTab==1}">
              <span class="row">
                <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==1"   class="img-mrg text-right" /><strong>1</strong> Carrier Information</span>
              </span>
            </a>
          </li>
          
          <li class="nav-item tb-siz" >
            <a class="nav-link" data-toggle="tab" href="#car-doc" (click)="onActive(2)" [ngClass]="{ 'active':utility.activeTab==2, 'disabled':utility.docCtrl==false}">
              <span class="row">
                <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==2"  class="img-mrg" /><strong>2</strong> Supporting Documents</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-conf" (click)="onActive(3)" [ngClass]="{ 'active':utility.activeTab==3,'disabled':utility.confirmCtrl==false}">
              <span class="row">
              <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==3" class="img-mrg" /><strong>3</strong> Confirmation</span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12" style="margin:0px;padding:0px;">
      <div class="tab-content" style="margin-top:20px;width:100%;">
        <div class="tab-pane mk-frm" id="car-info" [ngClass]="{ 'active':utility.activeTab==1}" *ngIf="utility.activeTab==1">
          <div class="row">
            <div class="col-12 mk-space">
              <companydetails #company></companydetails>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-doc" [ngClass]="{ 'active':utility.activeTab==2}" *ngIf="utility.activeTab==2">
          <div class="row">
            <div class="col-12" style="margin-top:20px!important;">
              <uploaddocument></uploaddocument>
            </div>
            <div class="col-12" *ngIf="utility.isBtnVisible">
              <button  title="Save & Continueto step 3" type="submit" id="btnSave" (click)="nextFrame()" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px;  ">Save & Continue</button>
              <button *ngIf="utility.isView" title="Previous tab" (click)="back()" type="submit" id="btnSave" class="btn btn-md m-clr pull-left hd-btn" style="width:auto; margin-right:4px;margin-bottom:5px;  ">Back</button>
              <button *ngIf="utility.isView" title="Cancel" (click)="utility.landingPage()" type="submit" id="btnSave" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:4px;margin-bottom:5px;  ">Close</button>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" [ngClass]="{ 'active':utility.activeTab==3}" *ngIf="utility.activeTab==3">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12">
              <submission [ctrlData]="ctrlData" [hideBackButton]="status == 1"></submission>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


